<template>
  <div>
    <div
      class="leaderboard"
      v-if="state == 1"
    >
      <div class="leaderboard-header">
        <img
          :src="prefixURL + 'mobile/img/mp/invite/invite_jiangpin.png'"
          alt=""
          width="100%"
          height="100%"
        >
        <div
          class="invite-btn"
          @click="showPopup = true"
          v-for="(item,index) in 6"
          :key="index"
        >邀请好友免费拿</div>
      </div>
      <div class="leaderboard-title">
        <i></i>
        <b>首单用户排行榜</b>
        <i></i>
      </div>
      <div class="leaderboard-tips">参与排行榜，赢巨额大礼</div>
      <van-count-down
        :time="leaderboardInfo.countDown * 1000"
        class="leaderboard-timer"
        @finish="finish"
      >
        <template #default="timeData">
          <span>{{timeData.days}}</span>
          <span>天</span>
          <span>{{ timeData.hours | timer }}</span>
          <span>时</span>
          <span>{{ timeData.minutes | timer }}</span>
          <span>分</span>
          <span>{{ timeData.seconds | timer }}</span>
          <span>秒</span>
        </template>
      </van-count-down>
      <div class="leaderboard-user">
        <div
          class="leaderboard-item"
          style="color: #FF7B2B; background-color: #ffffff;"
        >
          <span>排名</span>
          <span>奖励</span>
          <span>首单用户</span>
          <span>获奖用户</span>
        </div>
        <template v-if="leaderboardList.length">
          <div class="leaderboard-list">
            <div
              class="leaderboard-item"
              style="color: #333333"
              v-for="(item,index) in leaderboardList"
              :key="index"
            >
              <span>
                <img
                  :src="require(`../../assets/img/top${index + 1}.png`)"
                  alt
                  v-if="index < 3"
                >{{item.rank > 3 ? item.rank : ''}}
              </span>
              <span class="van-ellipsis">{{item.award}}</span>
              <span>***人</span>
              <span>{{item.phone}}</span>
            </div>
          </div>
          <div
            class="leaderboard-item leaderboard-self"
            v-if="leaderboardInfo.self.rank > 0"
          >
            <span><b>{{leaderboardInfo.self.rank}}</b></span>
            <span class="van-ellipsis">{{leaderboardInfo.self.award == "" ? "0元" : leaderboardInfo.self.award}}</span>
            <span>{{leaderboardInfo.self.count}}人</span>
          </div>
          <div
            class="leaderboard-item leaderboard-self leaderboard-differ"
            v-if="leaderboardInfo.self.rank > 0"
          >
            {{leaderboardInfo.self.differ}}
          </div>
          <div
            class="leaderboard-item leaderboard-self"
            style="justify-content: center"
            v-if="!leaderboardInfo.self.rank || leaderboardInfo.self.rank == 0"
          >
            您本次活动还未有新用户下单～
          </div>
        </template>
        <template v-else>
          <div class="notLeaderboard">
            <i class="iconfont icon-zhixiang1"></i>
            <p>排行榜更新中</p>
          </div>
        </template>
      </div>
      <div
        class="leaderboard-awarded flex-between"
        @click="goToDealis('/awardList')"
      >
        <span>查看历史获奖名单</span>
        <van-icon
          name="arrow"
          color="#999999"
        />
      </div>
      <div class="leaderboard-invite">
        <div class="invite-title">我的获奖</div>
        <div class="flex-between">
          <div class="invite-item line">
            <p class="invite-item-val">{{leaderboardInfo.brokerage}}<span>元</span></p>
            <p class="invite-val">共赚</p>
          </div>
          <dir
            class="invite-item line"
            @click="goToDealis('/awardRecord')"
          >
            <p class="invite-item-val">{{leaderboardInfo.awardNum}}<span>次</span></p>
            <p class="invite-val">获奖记录</p>
          </dir>
        </div>
      </div>
      <div class="leaderboard-rule">
        <div class="rule-title">活动规则</div>
        <div class="rule-image">
          <img
            :src="prefixURL + 'invite/rankings_pic_rule.png'"
            alt=""
          >
        </div>
      </div>
    </div>
    <div v-else>
      <img
        :src="prefixURL + 'invite/undefinedRankingList.png'"
        alt=""
        width="100%"
        height="100%"
        style="display: block"
      >
    </div>
    <share-popup
      :share-obj="shareInfo"
      :show-popup="showPopup"
      @hidePopup="showPopups"
    />
  </div>
</template>

<script>
import { topList, getState, shopInfo } from "@/api/join";
import sharePopup from "@/components/share/leaderboardShare";
export default {
  components: {
    sharePopup,
  },
  data() {
    return {
      active: 0,
      state: 1,// 1 表示开启活动，0表示关闭活动
      leaderboardList: [],
      leaderboardInfo: {
        self: {},
        countDown: 666
      },
      showPopup: false,
      shareInfo: {
        name: "",
        headpic: "",
        title: "",
        isBoss: true // 判断用户是否是店长
      },
      date: "" // 获取时间戳
    }
  },
  filters: {
    timer(val) {
      if (val < 10) {
        val = "0" + val;
      }
      return val;
    }
  },
  watch: {
    $route: {
      handler(newV) {
        if (this.GetQueryString('token')) {
          if (this.$store.getters.token != this.GetQueryString('token')) {
            this.$store.commit("user/SET_memberId", this.GetQueryString('memberId'));
            this.$store.commit("user/SET_token", this.GetQueryString('token'));
          }
          if (this.GetQueryString('date') != this.date) {
            this.date = this.GetQueryString('date');
            this.getTopList();
          }
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    subtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      //动态控制精度长度
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    goToDealis(value) {
      this.$router.push(value);
    },
    showPopups(bol) {
      this.showPopup = bol;
    },
    // 倒计时结束
    finish() {
      this.getTopList();
    },
    getTopList() {
      topList({
        page: {
          way: "0", // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "10", //数量
        },
        type: "1", //286 0是邀请，1 首单，后台默认接收参数0
      })
        .then((res) => {
          if (res.appStatus.errorCode == 0) {
            this.shareInfo.name = res.content.name;
            this.shareInfo.title = res.content.awardList[0].award;
            this.shareInfo.headpic = res.content.headpic;
            const list = res.content.list;
            const self = res.content.self;
            if (list.length) {
              let difference;
              // 判断用户是否上榜
              if (list[list.length - 1].rank * 1 >= self.rank * 1) {
                // 判断用户上榜后 排名是否是第一名
                if (self.rank * 1 > 1) {
                  // 判断用户排行与前一名首单用户人数差是否为0 为0 就显示1
                  if (this.subtr(list[self.rank - 2].count.replace("人", ""), self.count.replace("人", "")) > 0) {
                    difference = this.subtr(list[self.rank - 2].count.replace("人", ""), self.count.replace("人", ""));
                  } else {
                    difference = 1;
                  }
                  self.differ = `距离前一名首单用户差${difference}人哦~`;
                } else {
                  self.differ = "当前排名第一名，继续保持哦~";
                }
              } else {
                // 判断用户排行与排行榜最后一名首单用户人数差是否为0 为0 就显示1
                if (this.subtr(list[list.length - 1].count.replace("人", ""), self.count.replace("人", "")) > 0) {
                  difference = this.subtr(list[list.length - 1].count.replace("人", ""), self.count.replace("人", ""));
                } else {
                  difference = 1;
                }
                self.differ = `距离上榜首单用户差${difference}人哦~`;
              }
            }
            this.leaderboardList = list;
            this.leaderboardInfo = res.content;
          }
        })
    },
  },
  mounted() {
    getState({
      type: "0" //0用户排行榜，1店长排行榜，不传默认0
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.state = res.content.state;
      }
    })
    // shopInfo({}).then((res) => {
    //   if (res.appStatus.errorCode == 0) {
    //     this.shareInfo.isBoss = true;
    //   }
    //   if (res.appStatus.errorCode == 5244) {
    //     //如果不是店长，报错， 错误码：5244
    //     this.shareInfo.isBoss = false;
    //   }
    // });
  }
}
</script>

<style lang="scss" scoped>
.leaderboard {
  padding-bottom: 50px;
  background-color: #feeadd;
  .leaderboard-header {
    position: relative;
    .invite-btn {
      width: 136px;
      height: 35px;
      line-height: 35px;
      position: absolute;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      border-radius: 17px;
      background: linear-gradient(269deg, #ffa239 0%, #f35327 100%);
      &:nth-of-type(odd) {
        left: 36px;
      }
      &:nth-of-type(even) {
        right: 36px;
      }
      &:nth-of-type(1),
      &:nth-of-type(2) {
        top: 240px;
      }
      &:nth-of-type(3),
      &:nth-of-type(4) {
        top: 453px;
      }
      &:nth-of-type(5),
      &:nth-of-type(6) {
        top: 665px;
      }
    }
  }
  .leaderboard-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -20px;
    b {
      font-size: 19px;
      color: #fe7b2b;
    }
    i {
      width: 63px;
      height: 3px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      &:first-child {
        left: 26px;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          #fe7c2c 100%
        );
      }
      &:last-child {
        right: 26px;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0) 0%,
          #fe7b2b 100%
        );
      }
    }
  }
  .leaderboard-tips {
    margin-top: 15px;
    font-size: 12px;
    color: #666666;
    text-align: center;
  }
  .leaderboard-timer {
    text-align: center;
    margin-top: 15px;
    span {
      &:nth-of-type(odd) {
        width: 30px;
        height: 35px;
        line-height: 35px;
        display: inline-block;
        font-size: 19px;
        font-weight: bold;
        color: #f54c33;
        background-color: #fff8f1;
        border-radius: 5px;
      }
      &:nth-of-type(even) {
        font-size: 15px;
        margin: 0 7px;
      }
    }
  }
  .leaderboard-user {
    width: 351px;
    margin: 15px auto 0;
    overflow: hidden;
    border-radius: 7px;
    border: 1px solid #efd5d6;
    box-sizing: border-box;
  }
  .leaderboard-item {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 13px;
    &:nth-of-type(odd) {
      background-color: #fff8f1;
    }
    &:nth-of-type(even) {
      background-color: #ffffff;
    }
    span {
      &:nth-child(1) {
        width: 55px;
        margin-right: 5px;
        text-align: center;
      }
      &:nth-child(2) {
        width: 126px;
      }
      &:nth-child(3) {
        width: 52px;
        margin-right: 15px;
        text-align: center;
      }
      &:nth-child(4) {
        width: 96px;
      }
    }
    img {
      width: 25px;
      height: 25px;
    }
  }
  .leaderboard-self {
    color: #ffffff;
    background: linear-gradient(90deg, #fe0403 0%, #ff9403 100%);
    b {
      position: relative;
      &::after {
        content: "我";
        position: absolute;
        top: -6px;
        right: -17px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        font-size: 11px;
        color: #fe1c03;
        border-radius: 50%;
        background-color: #ffffff;
      }
    }
  }
  .leaderboard-differ {
    position: relative;
    justify-content: center;
    border-top: 1px solid #ffffff;
    z-index: 1;
  }
  .leaderboard-list {
    height: 400px;
    overflow-y: scroll;
  }
  .notLeaderboard {
    height: 400px;
    text-align: center;
    background-color: #fff8f1;
    i {
      display: block;
      padding-top: 135px;
      font-size: 60px;
      color: #ffb98e;
    }
    p {
      margin-top: 2px;
      font-size: 13px;
      color: #999999;
    }
  }
  .leaderboard-awarded {
    width: 351px;
    height: 44px;
    margin: 10px auto 0;
    padding: 0 15px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    background-color: #fff8f1;
    border: 1px solid #efd5d6;
    border-radius: 7px;
    box-sizing: border-box;
  }
  .leaderboard-invite,
  .leaderboard-rule {
    margin: 10px 12px 0;
    padding: 10px 0 14px;
    background-color: #fff8f1;
    border: 1px solid #efd5d6;
    border-radius: 7px;
    box-sizing: border-box;
  }
  .invite-title,
  .rule-title {
    padding-left: 15px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
  .rule-title {
    padding-left: 10px;
  }
  .rule-image {
    width: 331px;
    margin: 10px auto 0;
    img {
      width: 100%;
    }
  }
  .invite-item {
    flex: 1;
    padding-top: 10px;
    text-align: center;
    .invite-item-val {
      font-size: 20px;
      font-weight: bold;
      color: #ff1310;
      span {
        margin-left: 2px;
        font-size: 12px;
        color: #333333;
      }
    }
    .invite-val {
      margin-top: 5px;
      font-size: 12px;
      color: #999999;
    }
    .orders-val {
      font-size: 17px;
      font-weight: 800;
    }
    .orders-val-text {
      margin-top: 4px;
      font-size: 12px;
      color: #8d8d8d;
    }
  }
  .line {
    position: relative;
    &::before {
      content: "";
      width: 1px;
      height: 30px;
      position: absolute;
      background-color: #f4f4f4;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: 100;
    }
  }
}
</style>
<style scoped>
.leaderboard >>> .van-tab {
  font-weight: bold;
}
.leaderboard >>> .van-tab--active {
  font-size: 16px;
}
.leaderboard >>> .van-tabs__line {
  background-color: #ff7b2b;
}
</style>